import { jsonProperty, Serializable } from 'ts-serializable';

export class DealerCommentItemDto extends Serializable {
  @jsonProperty(Number, null) questionId: number | null = null;
  @jsonProperty(String, null) dealerNotes: string | null = null;
}
